import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {animate, state, style, transition, trigger} from "@angular/animations";


@Component({
  selector: 'modal-interactive',
  imports: [],
  standalone: true,
  templateUrl: './modal-interactive.component.html',
  styleUrl: './modal-interactive.component.scss',
  animations: [
    trigger('dialogAnimation', [
      state('enter', style({ opacity: 1, transform: 'scale(1)' })),
      state('exit', style({ opacity: 0, transform: 'scale(0.8)' })),

      transition('void => enter', [
        style({ opacity: 1, transform: 'scale(0.8)' }),
        animate('300ms ease-out')
      ]),
      transition('enter => exit', [
        animate('200ms ease-in', style({ opacity: 1, transform: 'scale(0.8)' }))
      ])
    ])
  ]
})
export class ModalInteractiveComponent {
  animationState = 'enter';

  constructor(public dialogRef: MatDialogRef<ModalInteractiveComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }



  close() {
    this.animationState = 'exit';
    setTimeout(() => this.dialogRef.close(), 150);
  }
}
